<div class="image-crop-container">
  <!-- Image and crop area -->
  <div class="image-wrapper" #imageContainer>
    @if (imageUrl) {
      <img
        #sourceImage
        [src]="imageUrl"
        class="source-image"
        (load)="onImageLoad()"
        draggable="false"
      />

      @if (imageLoaded) {
        <!-- Dark overlay outside crop area -->
        <div class="crop-overlay" [style.clipPath]="overlayClipPath"></div>

        <!-- Crop box (draggable) -->
        <div
          #cropBox
          class="crop-box"
          [class.dragging]="isDragging"
          [style.left.px]="cropX"
          [style.top.px]="cropY"
          [style.width.px]="cropWidth"
          [style.height.px]="cropHeight"
          (mousedown)="onMouseDown($event)"
          (touchstart)="onTouchStart($event)"
        >
          <!-- Corner indicators -->
          <div class="crop-corner top-left"></div>
          <div class="crop-corner top-right"></div>
          <div class="crop-corner bottom-left"></div>
          <div class="crop-corner bottom-right"></div>

          <!-- Grid lines for composition -->
          <div class="crop-grid">
            <div class="grid-line vertical" style="left: 33.33%"></div>
            <div class="grid-line vertical" style="left: 66.66%"></div>
            <div class="grid-line horizontal" style="top: 33.33%"></div>
            <div class="grid-line horizontal" style="top: 66.66%"></div>
          </div>

          <!-- Drag instruction -->
          <div class="drag-hint">
            <i class="fa fa-arrows-alt"></i>
            <span>{{ 'imageCrop.dragToPosition' | translate }}</span>
          </div>
        </div>
      }
    } @else {
      <div class="no-image">
        <i class="fa fa-image"></i>
        <span>{{ 'imageCrop.noImage' | translate }}</span>
      </div>
    }
  </div>

  <!-- Preview section -->
  @if (imageLoaded) {
    <div class="preview-section">
      <div class="preview-label">{{ 'imageCrop.preview' | translate }}</div>
      <div class="preview-container" [style.aspectRatio]="aspectRatio">
        <img
          [src]="imageUrl"
          class="preview-image"
          [style.transform]="'translate(' + (-cropX / cropWidth * 100) + '%, ' + (-cropY / cropHeight * 100) + '%) scale(' + (displayWidth / cropWidth) + ')'"
        />
      </div>
    </div>
  }

  <!-- Action buttons -->
  <div class="crop-actions">
    <button type="button" class="btn btn-light" (click)="cancel()">
      {{ 'common.cancel' | translate }}
    </button>
    <button type="button" class="btn btn-primary" (click)="confirm()" [disabled]="!imageLoaded">
      <i class="fa fa-check me-2"></i>
      {{ 'imageCrop.confirm' | translate }}
    </button>
  </div>
</div>
